// Resumo visual: mantém a mesma apuração de pagamentos usada nos cards.
export function resumoPagamentoComanda(value: any) {
  const pagamentos = Array.isArray(value.formaPagamento) ? value.formaPagamento : [];
  const parseBR = (s: any) => parseFloat((s || '0').toString().replace(/\./g, '').replace(/,/g, '.')) || 0;
  const totalPago = pagamentos.reduce((acc: number, campo: any) => {
    const valorNumerico = parseBR(campo.valor);
    const tipoCampo = (campo.tipo || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    if (tipoCampo.includes('mercado pago')) {
      return campo.pagou ? acc + valorNumerico : acc;
    }
    return acc + valorNumerico;
  }, 0);
  const pagoAMais = Math.max(0, Math.round((totalPago - parseBR(value.valorTotal)) * 100)) / 100;
  const restante = Math.max(0, parseBR(value.valorTotal) - totalPago);
  // A classificação considera os centavos exibidos e exige pagamento registrado.
  const aFechar = Boolean(value.sk) && totalPago > 0 && Math.round(restante * 100) === 0;
  const fmt = (n: number) => n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return { totalPago, aFechar, pagoAMais, pagoAMaisFormatado: fmt(pagoAMais), pagoFormatado: fmt(totalPago), restanteFormatado: fmt(restante) };
}
